module.exports = __webpack_public_path__ + "static/media/newlink.a8420b56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/newlink.svg
// module id = 1157
// module chunks = 0